import { GetTeamFeedInteractor } from './domain/interactors/get-team-feed.interactor';
import {
  AnyFeedItemEntityVersion,
  Cached,
  Collections,
  FeedCommonDefaultProvider,
} from '@uploadcam/common';
import { CollectionReference, Firestore } from 'firebase/firestore';
import { GetTeamFeedUpdatesInteractor } from './domain/interactors/get-team-feed-updates.interactor';
import { AddFeedItemInteractor } from './domain/interactors/add-feed-item.interactor';
import { getCollectionRef } from '../../@harmony/angular';
import { RemoveFeedItemsInteractor } from './domain/interactors/remove-feed-items.interactor';
import { UpdateFeedItemsAlbumInteractor } from './domain/interactors/update-feed-items-album.interactor';
import { UpdateFeedItemInteractor } from './domain/interactors/update-feed-item.interactor';
import { CommonProvider } from '../common/common.provider';
import { StorageProvider } from '../storage/storage.provider';

export abstract class FeedProvider {
  abstract provideAddFeedItem(): AddFeedItemInteractor;
  abstract provideGetTeamFeed(): GetTeamFeedInteractor;
  abstract provideGetTeamFeedUpdates(): GetTeamFeedUpdatesInteractor;
  abstract provideRemoveFeedItems(): RemoveFeedItemsInteractor;
  abstract provideUpdateFeedItem(): UpdateFeedItemInteractor;
  abstract provideUpdateFeedItemsAlbum(): UpdateFeedItemsAlbumInteractor;
}

export class FeedDefaultProvider implements FeedProvider {
  private readonly feedCollection: CollectionReference<AnyFeedItemEntityVersion>;
  private readonly feedCommon = new FeedCommonDefaultProvider();

  constructor(
    private readonly commonProvider: CommonProvider,
    private readonly firestore: Firestore,
    private readonly storageProvider: StorageProvider,
  ) {
    this.feedCollection = getCollectionRef(firestore, Collections.Feed);
  }

  @Cached()
  public provideAddFeedItem(): AddFeedItemInteractor {
    return new AddFeedItemInteractor(this.feedCollection);
  }

  @Cached()
  public provideGetTeamFeed(): GetTeamFeedInteractor {
    return new GetTeamFeedInteractor(
      this.feedCollection,
      this.feedCommon.provideFeedItemDtoToFeedItemMapper(),
    );
  }

  @Cached()
  public provideGetTeamFeedUpdates(): GetTeamFeedUpdatesInteractor {
    return new GetTeamFeedUpdatesInteractor(
      this.feedCollection,
      this.feedCommon.provideFeedItemDtoToFeedItemMapper(),
    );
  }

  @Cached()
  public provideRemoveFeedItems(): RemoveFeedItemsInteractor {
    return new RemoveFeedItemsInteractor(this.feedCollection, this.firestore);
  }

  @Cached()
  public provideUpdateFeedItem(): UpdateFeedItemInteractor {
    return new UpdateFeedItemInteractor(
      this.feedCollection,
      this.commonProvider.provideLogger(),
      this.storageProvider,
    );
  }

  @Cached()
  public provideUpdateFeedItemsAlbum(): UpdateFeedItemsAlbumInteractor {
    return new UpdateFeedItemsAlbumInteractor(this.feedCollection);
  }
}
